import React from 'react';
import { useQuery } from 'react-query';
import { FormControl, InputLabel, Select, MenuItem, CircularProgress } from '@mui/material';
import api from '@tyrio/api-factory';
import { DBBranchesApi } from '@tyrio/dto';

interface WorkOrderBranchSelectorProps {
  selectedBranchId: string | null;
  onBranchChange: (branchId: string | null) => void;
}

const WorkOrderBranchSelector: React.FC<WorkOrderBranchSelectorProps> = ({
  selectedBranchId,
  onBranchChange,
}) => {
  const { data: branches, isLoading, error } = useQuery(
    'get_branches',
    async (): Promise<DBBranchesApi['list']['response']> => {
      const response = await api.fetch<DBBranchesApi['list']>('get_branches', {
        search: '',
        page: 1,
        pageSize: 1000,
      });
      return response;
    },
    {
      refetchOnWindowFocus: false,
    }
  );

  if (error) {
    return null; // Silently fail if branches can't be loaded
  }

  // Filter only active branches
  const activeBranches = branches?.data?.filter(branch => branch.isActive === true) || [];

  return (
    <FormControl fullWidth>
      <InputLabel id="branch-selector-label">Branch</InputLabel>
      <Select
        labelId="branch-selector-label"
        id="branch-selector"
        value={selectedBranchId || ''}
        label="Branch"
        onChange={(event) => {
          const value = event.target.value;
          onBranchChange(value === '' ? null : value);
        }}
        disabled={isLoading}
      >
        <MenuItem value="">
          <em>All Branches</em>
        </MenuItem>
        {isLoading ? (
          <MenuItem disabled>
            <CircularProgress size={16} sx={{ mr: 1 }} />
            Loading...
          </MenuItem>
        ) : (
          activeBranches.map((branch) => (
            <MenuItem key={branch.id} value={branch.id.toString()}>
              {branch.branchName}
            </MenuItem>
          ))
        )}
      </Select>
    </FormControl>
  );
};

export default WorkOrderBranchSelector; 